var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdd = function SvgAdd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2",
    x: 0.75,
    y: 1.25,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    stroke: "#62657A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6\xE7\xBB\x93\xE5\x90\x88",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73733 5.11791C8.73733 4.77665 8.46068 4.5 8.11942 4.5C7.77816 4.5 7.50151 4.77665 7.50151 5.11791V7.9H4.6C4.26863 7.9 4 8.16863 4 8.5C4 8.83137 4.26863 9.1 4.6 9.1H7.50151V11.8821C7.50151 12.2234 7.77816 12.5 8.11942 12.5C8.46068 12.5 8.73733 12.2234 8.73733 11.8821V9.1H11.6388C11.9702 9.1 12.2388 8.83137 12.2388 8.5C12.2388 8.16863 11.9702 7.9 11.6388 7.9H8.73733V5.11791Z",
    fill: "#62657A"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add.12f60722.svg";